module.exports = __webpack_public_path__ + "img/52002753_L.7161be73.png";